export const dmsEn = {
  archive: {
    title: 'Document archive',
    subtitle: 'Central archive for general documents, contracts, records, and templates.',
  },
  manager: {
    title: 'Documents & files',
    description: 'Protected files with checksums and a traceable history.',
  },
  upload: {
    dropTitle: 'Drop files here or select them',
    dropHint: 'PDF, JPG, PNG, WebP, TXT, CSV, DOCX, or XLSX · up to 50 MB per file',
    select: 'Select files',
    categoryHint: 'The selected category applies to all files in this upload.',
    success_one: '{{count}} file uploaded.',
    success_other: '{{count}} files uploaded.',
  },
  search: { label: 'Search documents', placeholder: 'Name, title, or tag …' },
  fields: {
    title: 'Display name',
    category: 'Category',
    tags: 'Tags (comma-separated)',
    description: 'Description / note',
  },
  portal: {
    label: 'Share in customer portal',
    hint: 'Only explicitly shared files are visible to portal users for this customer.',
    visible: 'Visible in portal',
  },
  categories: {
    GENERAL_FILE: 'General file',
    CONTRACT: 'Contract',
    CERTIFICATE: 'Certificate',
    DATASHEET: 'Data sheet',
    INVOICE_RECEIPT: 'Invoice / receipt',
    CORRESPONDENCE: 'Correspondence',
    CUSTOMS_DECLARATION: 'Customs declaration',
    IMAGE: 'Image',
  },
  actions: { preview: 'Preview', previewNamed: 'Open preview for {{name}}', download: 'Download' },
  item: { uploaded: '{{date}} · {{user}}' },
  empty: {
    title: 'No files yet',
    description: 'Add the first documents using drag and drop.',
    search: 'No documents match your search.',
  },
  edit: { title: 'Edit document', success: 'Document details saved.' },
  delete: {
    title: 'Delete document permanently?',
    description:
      '“{{name}}” will be removed from the archive and protected storage. The operation remains in the audit log.',
    success: 'Document deleted.',
  },
  preview: {
    error: 'The preview could not be loaded.',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    page: 'Page',
    zoom: 'Zoom',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotateLeft: 'Rotate left',
    rotateRight: 'Rotate right',
    fullscreen: 'Full screen',
    textTruncated: 'The text preview was shortened to keep the viewer responsive.',
    uploadedAt: 'Uploaded at {{date}}',
  },
  errors: {
    list: 'Documents could not be loaded.',
    download: 'Download failed.',
    entityMissing: 'The related ERP entity is missing.',
    size: '“{{name}}” is empty or larger than 50 MB.',
    uploadFile: '“{{name}}” could not be uploaded.',
  },
  tabs: {
    partner: 'Documents & contracts',
    product: 'Files & data sheets',
    documentDetails: 'Document data',
    documentAttachments: 'Attachments',
  },
  batch: {
    title: 'Batch documents',
    subtitle: '{{product}} · Batch {{batch}}',
    back: 'Back to product',
    filesTitle: 'Certificates of analysis & laboratory reports',
    loadError: 'The batch could not be loaded.',
  },
} as const;
